import { ReactElement, ReactNode } from 'react';
import { PopperProps, Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import { CSSProperties, makeStyles } from '@mui/styles';
import { Placement } from './types';

const useStyles = makeStyles(theme => ({
  arrow: {
    color: theme.customComponents.tooltip.color
  },
  tooltip: {
    backgroundColor: theme.customComponents.tooltip.color,
    fontSize: '14px'
  }
}));

interface Props extends TooltipProps {
  children: ReactElement<any, any>;
  title: NonNullable<ReactNode>;
  offset?: [CSSProperties['offset'], CSSProperties['offset']];
  placement?: Placement;
}

const StandardTooltip = ({ children, title, placement = 'bottom', offset, ...props }: Props) => {
  const classes = useStyles();

  const popperProps: Partial<PopperProps> | undefined = offset
    ? {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset
            }
          }
        ]
      }
    : undefined;

  return (
    <MuiTooltip placement={placement} classes={classes} title={title} arrow PopperProps={popperProps} {...props}>
      {children}
    </MuiTooltip>
  );
};

export default StandardTooltip;
